import { useMemo } from "react";
import { useLeaseCompStore, useMapStore } from "..";
import IEntityWithIcon from "../interfaces/IEntityWithIcon";
import ILeaseComp from "../interfaces/ILeaseComp";
import useLeaseCompsWithGlobalFilters from "./useLeaseCompsWithGlobalFilters";

export default function useRadiusLeaseCompsOnMap(): ILeaseCompWithIcon[] {
    const leaseCompStore = useLeaseCompStore();
    const mapStore = useMapStore();

    const radiusLeaseComps = useMemo(() => {
        const radiusIdSet = new Set(leaseCompStore.radiusLeaseCompIds);
        return leaseCompStore.leaseComps.filter(lc => radiusIdSet.has(lc.id));
    }, [leaseCompStore.leaseComps, leaseCompStore.radiusLeaseCompIds]);

    const leaseComps = useLeaseCompsWithGlobalFilters(radiusLeaseComps);

    return useMemo(() => leaseComps.map(lc => ({
        ...lc,
        icon: lc.pipedriveCompanyId && mapStore.loadedLogoCompanyIds.includes(lc.pipedriveCompanyId)
            ? `location-marker-company-${lc.pipedriveCompanyId}`
            : "lease-comp-marker",
    })), [leaseComps, mapStore.loadedLogoCompanyIds]);
}

type ILeaseCompWithIcon = ILeaseComp & IEntityWithIcon
